import React from 'react'
import styled from 'styled-components'
import { Modal, TextInput, Button } from 'advenio-components'
import { Form } from 'formsy-react' // eslint-disable-line

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 32px;
`

const ApplyLabel = styled.div`
  margin: 16px;
`
const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-around;
`
const DeleteModal = props => (
  <Modal
    isOpened={props.open}
    onClose={props.onClose}
    headerTitle={'Eliminar Medicamento'}
  >
    <Container>
      <Form onSubmit={props.submitApply}>
        <ApplyLabel>
          ¿Seguro que deseas eliminar el medicamento en serie?
        </ApplyLabel>
        <ButtonContainer>
          <Button
            onClick={props.onClose}
          >
            Cancelar
          </Button>
          <Button
            primary
            type="submit"
          >
            Aceptar
          </Button>
        </ButtonContainer>
      </Form>

    </Container>
  </Modal>
)

export default DeleteModal



// WEBPACK FOOTER //
// ./src/Containers/Medicine/DeleteModal.jsx